import BringForwardIcon from 'assets/svgr-icons/Bring-Forward.svg'
import BringBackwardIcon from 'assets/svgr-icons/Bring-Backward.svg'
import BringToFrontIcon from 'assets/svgr-icons/Bring_Back.svg'
import BringToBackIcon from 'assets/svgr-icons/Bring_Front.svg'
import { T } from 'consts/translationKeys'
import { TMenuRow, ZOrderAction } from './types'

export const MENU_ROWS: TMenuRow[] = [
  {
    type: 'item',
    action: ZOrderAction.BringForward,
    labelKey: T.Z_ORDER_BRING_FORWARD,
    icon: <BringForwardIcon />,
    id: 1
  },
  {
    type: 'item',
    action: ZOrderAction.BringBackward,
    labelKey: T.Z_ORDER_BRING_BACKWARD,
    icon: <BringBackwardIcon />,
    id: 2
  },
  { type: 'divider', id: 3 },
  {
    type: 'item',
    action: ZOrderAction.BringToFront,
    labelKey: T.Z_ORDER_BRING_TO_FRONT,
    icon: <BringToBackIcon />,
    id: 4
  },
  {
    type: 'item',
    action: ZOrderAction.BringToBack,
    labelKey: T.Z_ORDER_BRING_TO_BACK,
    icon: <BringToFrontIcon />,
    id: 5
  }
]
